// This is for dangerously set HTML which we provide
/* eslint-disable react/no-danger */
import React from 'react';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';
import Checkbox from 'views/ui/form_elements/checkbox';
import classnames from 'classnames';
import ModalActionCreator from 'action_creators/modal';

import './index.scss';

export default class Waiver extends React.Component {
  linkClick = (e) => {
    ModalActionCreator.show({
      content: this._modalContent(),
      triggeringElement: e.currentTarget,
      className: 'small Waiver-Modal',
    });
  };

  _closeModal(e) {
    e.preventDefault();
    ModalActionCreator.hide();
  }

  _modalContent() {
    const { question } = this.props;
    const { popup_link_name: popupLinkName, popup_link_text: popupLinkText } =
      question;
    return (
      <div className="CheckoutWaiver-Modal-content">
        <div dangerouslySetInnerHTML={{ __html: popupLinkName }} />
        {popupLinkText && (
          <div
            className="popup-body"
            dangerouslySetInnerHTML={{ __html: popupLinkText }}
          />
        )}
        <div className="close-modal">
          <a href="#" onClick={this._closeModal}>
            {t('CLOSE')}
          </a>
        </div>
      </div>
    );
  }

  hasError = () => this.props?.errors?.length >= 1;

  renderErrors = () => {
    loadLocales(SessionStore.state.get('i18n'));
    if (this.hasError()) {
      // Quick fix for single-choice required waiver checkout questions
      const { question } = this.props;
      let error = this.props.errors[0];
      if (
        question.required &&
        question.input_type === 'waiver' &&
        error.includes('Please select an option')
      ) {
        error = `${t('PLEASE_SELECT')}.`;
      }
      return <span className="ar-radio-error">{error}</span>;
    }
    return null;
  };

  render() {
    const { question, value } = this.props;
    const val = value === 'yes';

    const radioWrapperClasses = classnames('ar-radio-wrapper', {
      error: this.hasError(),
    });

    let popupLink = null;
    if (question.popup_link_name) {
      popupLink = (
        <span className="brand-color" style={{ cursor: 'pointer' }}>
          {question.popup_link_name}
        </span>
      );
    }

    if (question) {
      const { onChange } = this.props;
      return (
        <div
          className={radioWrapperClasses}
          ref="input_wrapper"
          data-testid={this.props['data-testid']}
        >
          <Checkbox
            value={val}
            onChange={onChange}
            linkClick={this.linkClick}
            popup_link_name={question.popup_link_name}
            popup_link_text={question.popup_link_text}
            label={question.text}
          >
            {' '}
            {popupLink}
          </Checkbox>
          {question.subtext && (
            <div
              className="question-subtext contains-brand-link"
              dangerouslySetInnerHTML={{
                __html: question.subtext,
              }}
            />
          )}
          {this.renderErrors()}
        </div>
      );
    }
    return null;
  }
}
